import {
    CLAPI
} from '../clchart/cl.api.js'
import * as DATAS from '../datas/transdata.js'

export const FWIDTH = 125

export const CHART_CORREL_MCLASS = {
    style: 'horizontal', // 'vertical'
    title: {
        width: FWIDTH,
        label: '因子相关度',
    },
    maxchs: 4,
    ctrls: []
}

// export const MINUTES = [945, 1045, 1330, 1445]

export const CHART_CORREL_MINUTE = {
    style: 'horizontal', // 'vertical'
    title: {
        label: '分时',
    },
    maxchs: 4,
    ctrls: []
}

export function onInit(classes, minutes) {
    CHART_CORREL_MCLASS.ctrls = []
    for (let wvi = 0; wvi < classes.length; wvi++) {
        CHART_CORREL_MCLASS.ctrls.push({
            label: classes[wvi],
            clickValue: classes[wvi],
        })
    }
    CHART_CORREL_MINUTE.ctrls = []
    for (let wvi = 0; wvi < minutes.length; wvi++) {
        CHART_CORREL_MINUTE.ctrls.push({
            label: minutes[wvi],
            clickValue: minutes[wvi],
        })
    }
}

// 仅仅返回二维数组
export function ToWCorrel(indata, fnums) {
    let vars = []
    for (let fi = 0; fi < fnums; fi++) {
        const var1 = new Array(fnums);
        vars.push(var1)
    }
    for (let index = 0; index < indata.datas.length; index++) {
        const lindex = CLAPI.getData(indata, 'lindex', index)
        const rindex = CLAPI.getData(indata, 'rindex', index)
        vars[lindex][rindex] = CLAPI.getData(indata, 'correl', index)
    }
    return vars;
}

export const CHART_CORREL_FACTORS = {
    style: 'vertical', // 'vertical'
    title: {
        label: '因子集',
        height: 23,
    },
    ctrls: []
}
export function setFactorsTitle(name) {
    CHART_CORREL_FACTORS.title.label = name
}
export function clearFactors() {
    CHART_CORREL_FACTORS.ctrls = []
}

export function incrFactors(fname) {
    // console.log(fname);
    const info = {
        label: fname,
        clickValue: fname,
    }
    CHART_CORREL_FACTORS.ctrls.push(info)
}
